"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferLetterTemplateUpdateRequestSchema = exports.OfferLetterTemplateCreateRequestSchema = exports.OfferLetterTemplateListQuerySchema = exports.OfferLetterTemplateIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.OfferLetterTemplateIdPathParamsSchema = zod_1.z.object({ templateId: schemas_1.UUIDSchema });
exports.OfferLetterTemplateListQuerySchema = schemas_1.PaginationQuerySchema;
exports.OfferLetterTemplateCreateRequestSchema = schemas_1.OfferLetterTemplateSchema.omit({ id: true, updatedAt: true });
exports.OfferLetterTemplateUpdateRequestSchema = exports.OfferLetterTemplateCreateRequestSchema.partial();
